// extracted by mini-css-extract-plugin
export default {"page":"styles_page__wQ6Ro","container":"styles_container__xkJAz","wrapper":"styles_wrapper__CNm8h"};